<template>
  <div class="relatorios p-4">

    <v-card>
      <v-card-title>
        Construtor de Relatórios
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <label class="font-weight-bold">Categoria</label>
							<v-autocomplete no-filter v-model="categoriaSelecionada" outlined dense
								:items="categorias2"></v-autocomplete>
          </v-col>
          <v-col>
            <label class="font-weight-bold">Modelo</label>
							<v-autocomplete no-filter v-model="modeloRelatorio" outlined dense
								:items="modelos"></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card v-if="modeloRelatorio === 'Comparativo'" class="mt-2">
      <v-card-title>
        Configuração Comparativo
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
             <label class="font-weight-bold">Campo de comparação</label>
							<v-autocomplete no-filter v-model="campoComparacao" outlined dense
								:items="campos"></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Configurações extras se for comparativo -->
    <div v-if="modeloRelatorio === 'Comparativo'" class="mb-4 p-2 border bg-gray-50">
      <h3>Configuração Comparativo</h3>

      <div class="mb-2">
        <label>Campo de comparação:</label>
        <select v-model="campoComparacao">
          <option value="idempresa">Empresa</option>
          <option value="idproduto">Produto</option>
        </select>
      </div>

      <div class="mb-2">
        <label>Quantidade de comparações:</label>
        <input type="number" v-model.number="qtdComparacoes" min="2" />
      </div>

      <div>
        <label>Itens para comparar:</label>
        <div v-for="(item, index) in comparacoes" :key="index" class="mb-1">
          <input
            type="text"
            v-model="comparacoes[index]"
            placeholder="Digite o valor (ex: 101 ou PROD45)"
          />
        </div>
      </div>
    </div>

    <div class="flex">
      <!-- Campos disponíveis -->
      <div class="w-1/2 p-2 border">
        <h3>Campos disponíveis ({{ categoriaSelecionada }})</h3>
        <draggable 
          :list="camposDisponiveis"
          :group="{ name: 'campos', pull: 'clone', put: false }"
          :clone="clonarCampo"
        >
          <div v-for="campo in camposDisponiveis" :key="campo" class="campo-item">
            {{ campo }}
          </div>
        </draggable>
      </div>

      <!-- Relatório montado -->
      <div class="w-1/2 p-2 border">
        <h3>Meu relatório</h3>
        <draggable v-model="camposSelecionados" :group="'campos'" class="drop-zone">
          <div v-for="(campo, index) in camposSelecionados" :key="index" class="campo-item">
            {{ campo }}
            <button @click="removerCampo(index)">x</button>
          </div>
        </draggable>
      </div>
    </div>

    <!-- Configuração de totais -->
    <div class="mt-4">
      <label>
        <input type="checkbox" v-model="mostrarTotais" />
        Mostrar totais
      </label>
    </div>

    <!-- Botão exportar -->
    <div class="mt-4">
      <button @click="exportarRelatorio">Exportar Relatório</button>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  components: { draggable },
  data() {
    return {
      categorias: {
        Compras: ["Fornecedor", "Data da Compra", "Valor Total", "Produto"],
        Vendas: ["Cliente", "Data da Venda", "Valor", "Quantidade"],
        Estoque: ["Produto", "Quantidade em Estoque", "Local", "Última Entrada"]
      },
      modelos: ["Listagem", "Comparativo"],
      categorias2: ["Compras", "Vendas", "Estoque"],
      campos: ["idproduto", "idempresa"],
      categoriaSelecionada: "Compras",
      modeloSelecionado: "Listagem",

      modeloRelatorio: "listagem", // listagem | comparativo
      campoComparacao: "idempresa",
      qtdComparacoes: 2,
      comparacoes: ["", ""],

      camposSelecionados: [],
      mostrarTotais: false
    };
  },
  watch: {
    qtdComparacoes(newVal) {
      // ajusta array comparacoes conforme quantidade definida
      if (newVal > this.comparacoes.length) {
        while (this.comparacoes.length < newVal) {
          this.comparacoes.push("");
        }
      } else {
        this.comparacoes.splice(newVal);
      }
    }
  },
  computed: {
    camposDisponiveis() {
      return this.categorias[this.categoriaSelecionada];
    }
  },
  methods: {
    clonarCampo(campo) {
      return campo;
    },
    removerCampo(index) {
      this.camposSelecionados.splice(index, 1);
    },
    exportarRelatorio() {
      let config = {
        modelo: this.modeloRelatorio,
        categoria: this.categoriaSelecionada,
        campos: this.camposSelecionados,
        totais: this.mostrarTotais
      };

      if (this.modeloRelatorio === "comparativo") {
        config.comparacao = {
          campo: this.campoComparacao,
          itens: this.comparacoes
        };
      }

      console.log("Exportando relatório...", config);
      alert("Relatório exportado (simulação). Veja no console os dados.");
    }
  }
};
</script>

<style scoped>
.campo-item {
  padding: 5px;
  margin: 4px;
  background: #f1f1f1;
  border: 1px solid #ccc;
  cursor: grab;
}
.drop-zone {
  min-height: 150px;
  background: #fafafa;
  padding: 10px;
}
</style>
